'use strict';

var angular = require('angular');
var app = require('./modules/gbip.module.js');

app.config(require('./config/route.config.js'));
app.config(require('./config/http.config.js'));
app.config(require('./config/tooltip.config.js'));
app.config(require('./config/notifications.config.js'));

app.constant('AUTH_EVENTS', require('./config/authEvents.constant.js'));
app.constant('USER_ROLES', require('./config/userRoles.constant.js'));
app.constant(
  'USER_ROLES_LABEL',
  require('./config/userRolesLabel.constant.js')
);
app.constant('ROLE_NAV', require('./config/roleNav.constant.js'));
app.constant('REDIRECT', require('./config/redirect.constant.js'));
app.constant('LOGIN_URL', require('./config/loginUrl.constant.js'));
app.constant('MERCH_STATUS', require('./config/merchStatus.constant.js'));
app.constant('META_STATUS', require('./config/metaStatus.constant.js'));
app.constant('ASSET_STATUS', require('./config/assetStatus.constant.js'));
app.constant('JOB_TYPE', require('./config/jobType.constant.js'));
app.constant('UPDATE_PARAMS', require('./config/updateParams.constant.js'));
app.constant('ASSET_HIGH_RES_WIDTH', 2000);
app.constant(
  'CHARACTER_LIMITS',
  require('./config/characterLimits.constant.js')
);
app.constant(
  'PRIORITY_CROP_TYPE_SIZES',
  require('./config/priorityCropTypeSizes.constant')
);
app.constant('COLOR_REFERENCE', require('./config/colorReference.constant.js'));
app.constant('HISTORY', require('./config/history.constant.js'));
app.constant('ACTIVITY', require('./config/activity.constant.js'));

angular.module('infinite-scroll').value('THROTTLE_MILLISECONDS', 250);

app.run(require('./config/routeChange.event.js'));

app.run([
  'FeatureFlagService',
  '$urlRouter',
  function (FeatureFlagService, $urlRouter) {
    FeatureFlagService.init().then(function () {
      $urlRouter.listen();
      $urlRouter.sync();
    });
  },
]);
app.run(require('./config/history.event.js'));
app.run(require('./config/globals.js'));

app.controller('AppController', require('./controllers/app.controller.js'));
app.controller(
  'RedirectToReactController',
  require('./controllers/redirectToReact.controller.js')
);

app.factory('AuthService', require('./services/auth.service.js'));
app.service('Session', require('./services/session.service.js'));
app.service('ScannerService', require('./services/scanner.service.js'));
app.service('JobService', require('./services/job.service.js'));
app.service('ProductService', require('./services/product.service.js'));
app.service('HistoryService', require('./services/history.service.js'));
app.service('NoteService', require('./services/note.service.js'));
app.service(
  'LinkedProductService',
  require('./services/linkedProduct.service.js')
);
app.service('BatchService', require('./services/batch.service.js'));
app.service('EventLoggerService', require('./services/eventLogger.service.js'));
app.service(
  'AssignedUsersService',
  require('./services/assignedUsers.service.js')
);
app.service(
  'ProblemSolveIndicatorService',
  require('./services/problemSolveIndicator.service.js')
);
app.factory('RouterTracker', require('./services/router.tracker.factory.js'));
app.factory('CSVExporter', require('./services/csv.factory.js'));
app.factory(
  'HttpErrorInterceptor',
  require('./services/httpErrorInterceptor.factory.js')
);

app.config([
  '$httpProvider',
  function ($httpProvider) {
    $httpProvider.interceptors.push('HttpErrorInterceptor');
  },
]);

app.service(
  'ReactNavigationService',
  require('./services/reactNavigation.service.js')
);
app.service(
  'LegacyRedirectService',
  require('./services/legacyRedirect.service.js')
);
app.service('FeatureFlagService', require('./services/featureFlag.service.js'));
app.service('AnimationService', require('./services/animation.service.js'));

app.filter('regex', require('./filters/regex.filter.js'));
app.filter('tahead', require('./filters/tahead.filter.js'));
app.filter('ddisplay', require('./filters/dateDisplay.filter.js'));
app.filter('openAssets', require('./filters/openAssets.filter.js'));
app.filter('filesize', require('./filters/filesize.filter.js'));
app.filter('capitalize', require('./filters/capitalize.filter.js'));
app.filter('trust', require('./filters/trust.filter.js'));

app.component(
  'fileUploadGroup',
  require('./directives/ui/fileUploadGroup.component.js')
);
app.component('fcoGroup', require('./directives/ui/fcoGroup.component.js'));
app.component(
  'otherAssetsGroup',
  require('./directives/ui/otherAssetsGroup.component.js')
);
app.component('fileUpload', require('./directives/ui/fileUpload.component.js'));
app.component('imgModal', require('./directives/ui/imgModal.component.js'));
app.component('imgHero', require('./directives/ui/imgHero.component.js'));
app.component(
  'colorReferenceFiles',
  require('./directives/ui/colorReferenceFiles.component.js')
);

app.directive(
  'jobCompact',
  require('./directives/job/views/compact.directive.js')
);
app.directive('jobFull', require('./directives/job/views/full.directive.js'));
app.component('task', require('./directives/job/task.component.js'));
app.component('thumbnail', require('./directives/job/thumbnail.component.js'));
app.service(
  'DownloadStatusService',
  require('./services/downloadStatus.service.js')
);
app.component(
  'downloadStatus',
  require('./directives/ui/downloadStatus.component.js')
);
app.component(
  'progressBar',
  require('./directives/ui/progressBar.component.js')
);

app.constant('SEARCH_CONSTANTS', require('./search/search.constant.js'));
app.service('SearchService', require('./search/search.service.js'));

app.controller(
  'QaDetailController',
  require('./controllers/qa.detail.controller.js')
);
app.service('QAService', require('./services/qa.service.js'));
app.service('CanvasService', require('./services/canvas.service.js'));
app.component('qaRejection', require('./directives/qa/rejection.component.js'));
app.component(
  'rejectionPanel',
  require('./directives/qa/rejectionPanel.component.js')
);
app.component(
  'imageViewer',
  require('./directives/qa/imageViewer.component.js')
);
app.component(
  'imageViewerHero',
  require('./directives/qa/imageViewerHero.component.js')
);
app.directive('imageThumb', require('./directives/qa/imageThumb.directive.js'));
app.controller(
  'ImageThumbController',
  require('./directives/qa/imageThumb.controller.js')
);
app.component('annotation', require('./directives/qa/annotation.component.js'));
app.component(
  'imageZoom',
  require('./directives/qa/imageViewerZoom.component.js')
);
app.component('qaApprove', require('./directives/qa/approve.component.js'));

app.service('TransferService', require('./transfer/transfer.service.js'));
app.component('transfer', require('./transfer/transfer.component.js'));

app.component('detailHeader', require('./detail/header.component.js'));
app.component('productDetail', require('./detail/productDetail.component.js'));
app.component('qaStatus', require('./detail/qaStatus.component.js'));
app.component('assetHero', require('./detail/assetHero.component.js'));
app.component('attachments', require('./detail/attachments.component.js'));
app.component('history', require('./detail/history.component.js'));
app.directive('onLoad', require('./detail/onLoad.directive.js'));
app.component('jobNotes', require('./detail/jobNotes.component.js'));
app.component('note', require('./detail/note.component.js'));
app.component('problemModal', require('./detail/problemModal.component.js'));
app.component(
  'closeJobModal',
  require('./initiateJob/closeJobModal.component.js')
);

app.service('JobFormService', require('./services/jobForm.service.js'));
app.service('JobTypeService', require('./services/jobType.service.js'));

app.component('gbipIcon', require('./ui/icons/icon.component.js'));
app.component('confidential', require('./ui/icons/confidential.component.js'));
app.component('priority', require('./ui/icons/priority.component.js'));
app.component('jobType', require('./ui/icons/jobType.component.js'));
app.component(
  'rejectionIndicator',
  require('./ui/icons/rejectionIndicator.component.js')
);
app.component('cropTypes', require('./ui/icons/cropTypes.component.js'));

app.component('gbipTextarea', require('./ui/forms/textarea.component.js'));
app.component('typeahead', require('./ui/forms/typeahead.component.js'));
app.component('formDropdown', require('./ui/forms/dropdown.component.js'));
app.directive('gbipInput', require('./ui/forms/input.directive.js'));
app.directive('checkbox', require('./ui/forms/checkbox.directive.js'));
app.component('datepicker', require('./directives/ui/datepicker.component.js'));

app.component('tabs', require('./ui/tabs/tabs.component.js'));
app.component('pane', require('./ui/tabs/pane.component.js'));

app.component('gbipHeader', require('./global/header.component.js'));
app.component('gbipModal', require('./ui/modal.component.js'));
app.component('loading', require('./ui/loading.component.js'));
app.directive('staticInclude', require('./ui/staticInclude.directive.js'));
app.directive('refresher', require('./ui/refresher.directive.js'));

app.service('StatusService', require('./statusChange/status.service.js'));
app.service('UsersService', require('./services/users.service.js'));
app.component(
  'statusChange',
  require('./statusChange/statusChange.component.js')
);
app.component(
  'expectedViews',
  require('./statusChange/expectedViews/expectedViews.component.js')
);
app.component('jobLink', require('./directives/job/jobLink.component.js'));
